import { Action, ThunkDispatch } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';

import { MaterialListsSliceState } from '../store/materialListsSlice';

export const useMaterialListsSelector: TypedUseSelectorHook<MaterialListsSliceState> = useSelector;
export const useMaterialListsDispatch: () => ThunkDispatch<MaterialListsSliceState, void, Action> = useDispatch;
